<div class="container-section-title">
  <div class="container">
    <div class="row">
      <div class="col-24">
        <h2>{{sectionTitle}}</h2>
      </div>
    </div>
  </div>
</div>